import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useConteo, SUAVE } from '../dashboard/motion';

/**
 * El anillo con el porcentaje de la audiencia.
 *
 * Un número suelto —"155"— no dice nada sin el total. El anillo muestra qué
 * parte de los clientes activos recibiría el aviso, que es lo que permite
 * decidir si vale la pena mandarlo.
 */
export default function AnilloPorcentaje({ valor, total, color = 'primary', tamano = 104 }) {
  const parte = total > 0 ? Math.min(valor / total, 1) : 0;
  const animado = useConteo(parte * 100, 1100);

  const radio = (tamano - 12) / 2;
  const vuelta = 2 * Math.PI * radio;
  const pintado = (animado / 100) * vuelta;

  return (
    <Box sx={{ position: 'relative', width: tamano, height: tamano, flexShrink: 0 }}>
      <Box
        component="svg"
        viewBox={`0 0 ${tamano} ${tamano}`}
        sx={{ width: 1, height: 1, transform: 'rotate(-90deg)' }}
      >
        <circle
          cx={tamano / 2} cy={tamano / 2} r={radio}
          fill="none" strokeWidth="9"
          stroke="currentColor"
          style={{ color: 'rgba(24,58,42,.09)' }}
        />
        <Box
          component="circle"
          cx={tamano / 2} cy={tamano / 2} r={radio}
          fill="none" strokeWidth="9" strokeLinecap="round"
          strokeDasharray={`${pintado} ${vuelta}`}
          sx={{ stroke: (t) => t.palette[color].main, transition: `stroke .2s ${SUAVE}` }}
        />
      </Box>

      <Box
        sx={{
          position: 'absolute', inset: 0,
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
        }}
      >
        <Typography sx={{ fontSize: 24, fontWeight: 800, lineHeight: 1, color: `${color}.darker` }}>
          {Math.round(animado)}%
        </Typography>
        <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: .25 }}>
          de {total}
        </Typography>
      </Box>
    </Box>
  );
}
